import React, { type SVGProps } from "react";
import { iconSizes, type IconProps } from "./utils/shared";
const Text = (props: SVGProps<SVGSVGElement> & IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    width={props.size ? iconSizes[props.size] : iconSizes["s"]}
    height={props.size ? iconSizes[props.size] : iconSizes["s"]}
    title="Text"
    {...props}
  >
    <path d="M13 6V21H11V6H5V4H19V6H13Z" />
  </svg>
);
export default React.memo(Text);
